import { useMutation } from '@apollo/client'
import { RemoveTest, RemoveTestVariables } from '../../types'
import { REMOVE_TEST_MUTATION } from './operations'

export const useRemoveTest = () =>
  useMutation<RemoveTest, RemoveTestVariables>(REMOVE_TEST_MUTATION)
